import { Module } from "vuex";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { UserState } from "./types";
import { RootState } from "../types";

const initialState: UserState = {
  user: undefined
};

export const user: Module<UserState, RootState> = {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
};
